import { useState } from 'react';
import { Headphones, LayoutDashboard, Network, ShieldOff, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth';
import { userHasRole } from '../../roles';
import {
  TelephonyAdminOverview,
  TelephonyEmployeesPanel,
  TelephonyRoutesPanel,
  TelephonySettings,
} from '../../telephony';
import { TelephonyBlacklistPanel } from './TelephonyBlacklistPanel';

type TelephonyAdministrationTab = 'OVERVIEW' | 'EMPLOYEES' | 'ROUTES' | 'SYSTEM' | 'BLACKLIST';

export function TelephonyAdministration() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState<TelephonyAdministrationTab>('OVERVIEW');

  if (!userHasRole(user, 'ADMIN')) return <div className="form-error">Настройки телефонии доступны только администратору.</div>;

  return <div className="telephony-page">
    <nav className="telephony-stage-nav surface" aria-label="Администрирование телефонии">
      <button type="button" className={tab === 'OVERVIEW' ? 'active' : ''} onClick={() => setTab('OVERVIEW')}><LayoutDashboard /><span><b>Обзор</b><small>Состояние АТС</small></span></button>
      <button type="button" className={tab === 'EMPLOYEES' ? 'active' : ''} onClick={() => setTab('EMPLOYEES')}><Users /><span><b>Сотрудники</b><small>Добавочные и права</small></span></button>
      <button type="button" className={tab === 'ROUTES' ? 'active' : ''} onClick={() => setTab('ROUTES')}><Network /><span><b>Маршруты</b><small>Группы вызова</small></span></button>
      <button type="button" className={tab === 'SYSTEM' ? 'active' : ''} onClick={() => setTab('SYSTEM')}><Headphones /><span><b>SIP и АТС</b><small>Провайдер, WebRTC, записи</small></span></button>
      <button type="button" className={tab === 'BLACKLIST' ? 'active' : ''} onClick={() => setTab('BLACKLIST')}><ShieldOff /><span><b>Чёрный список</b><small>Блокировка звонков</small></span></button>
    </nav>

    {tab === 'OVERVIEW' && <TelephonyAdminOverview
      onOpenDiagnostics={() => navigate('/monitoring')}
      onOpenEmployees={() => setTab('EMPLOYEES')}
      onOpenCalls={() => navigate('/calls')}
      onOpenSettings={() => setTab('SYSTEM')}
    />}
    {tab === 'EMPLOYEES' && <TelephonyEmployeesPanel />}
    {tab === 'ROUTES' && <TelephonyRoutesPanel />}
    {tab === 'SYSTEM' && <TelephonySettings />}
    {tab === 'BLACKLIST' && <TelephonyBlacklistPanel />}
  </div>;
}
